import React from 'react';

const GeometricDecorations: React.FC = () => {
  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none">
      <div className="absolute -top-24 -right-24 w-72 h-72 bg-emerald-300 opacity-20 rounded-full blur-3xl" />
      <div className="absolute -bottom-20 -left-20 w-56 h-56 bg-blue-300 opacity-20 rounded-full blur-3xl" />
      <div className="absolute top-10 left-10 w-40 h-40 bg-emerald-200 opacity-10 rotate-12 rounded-3xl" />

      <div
        className="absolute bottom-16 right-16 opacity-10"
        style={{
          width: 0,
          height: 0,
          borderLeft: '60px solid transparent',
          borderRight: '60px solid transparent',
          borderBottom: '100px solid rgb(16 185 129)',
        }}
      />

      <div className="absolute top-1/4 left-1/3 w-6 h-6 bg-emerald-400 rounded-full opacity-20" />
      <div className="absolute bottom-1/3 right-1/4 w-4 h-4 bg-blue-400 rounded-full opacity-20" />
      <div className="absolute top-2/3 left-1/5 w-8 h-8 bg-purple-400 rounded-full opacity-10" />
    </div>
  );
};

export default GeometricDecorations;